import CButton from "components/CButton";
import CDialog from "components/CDialog";
import useAnnuncementCoborrower from "./useAnnuncementCoborrower";

const AnnuncementCoborrowerPending = () => {
  const { handleAddAnnuncementCoborrowerPendign, loading, openModal } =
    useAnnuncementCoborrower();

  return (
    <CDialog
      fullWidth
      maxWidth="xs"
      icon="warning"
      scroll={"paper"}
      sx={{ padding: "2rem" }}
      title="Coborrower process is pending"
      description="We are waiting for the coborrower to finish his process to continue."
      open={openModal}
      onClose={handleAddAnnuncementCoborrowerPendign}
    >
      <CButton
        fullWidth
        loading={loading}
        disabled={loading}
        onClick={handleAddAnnuncementCoborrowerPendign}
        variant="contained"
      >
        Accept
      </CButton>
    </CDialog>
  );
};

export default AnnuncementCoborrowerPending;
